// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import { connect } from 'react-redux';
import LoginOTPPageComponent from 'components/login-page/Login-OTP';
import { CombinedState } from 'reducers/interfaces';
import { loginotpAsync } from 'actions/auth-actions';
import { loginssoAsync } from 'actions/auth-actions';
interface StateToProps {
    fetching: boolean;
    renderResetPassword: boolean;
    otpdata: any;
}

interface DispatchToProps {
    onotpVerify: typeof loginotpAsync;
    renderResendOPT: typeof loginssoAsync;
}

function mapStateToProps(state: CombinedState): StateToProps {
    return {
        fetching: state.auth.fetching,
        renderResetPassword: state.auth.allowResetPassword,
         otpdata: state.auth.otpdata,
    };
}

const mapDispatchToProps: DispatchToProps = {
    onotpVerify: loginotpAsync,
     renderResendOPT: loginssoAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginOTPPageComponent);
